module.exports = __webpack_public_path__ + "img/imagetext.25dde29c.svg";